<template>
  <div id="app">
    <div class="header"></div>
    <div class="main">
      <router-view/>
    </div>
    <div class="footer">
      <p class="note">
        Tenha o seu <a href="https://api.whatsapp.com/send?phone=5547992840161">
          zapie.xyz/seunome
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  html, body {
    margin: 0;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .header {
    flex: 1;
  }

  .main {
    flex: 3;
  }

  .footer {
    flex: 1;
  }

  .note {
    margin: 0 auto;
    background-color: #cccccc3d;
    color: #2c3e50;
    padding: 1.2rem 1.4rem;
    border-radius: 1.5rem;
    border-bottom-left-radius: 0;
    max-width: 15rem;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue